export default __webpack_public_path__ + "static/media/fact_sheet41.2fb9c24b.png";